import React from 'react'
import type { StepData } from '../../../services/onboardingService'

interface PaymentMethodStepProps {
  onComplete?: (stepData: StepData) => Promise<void>
  stepData?: any
  stepKey?: string
}

const PaymentMethodStep: React.FC<PaymentMethodStepProps> = ({
  onComplete,
  stepData,
}) => {
  const handleComplete = async () => {
    if (onComplete) {
      await onComplete({
        completedAt: new Date().toISOString(),
        placeholder: true,
      })
    }
  }

  return (
    <div className="max-w-2xl mx-auto">
      <div className="mb-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-2">
          Selección de Método de Pago para Pago Inicial
        </h2>
        <p className="text-gray-600">
          Configuración del método de pago inicial
        </p>
      </div>

      {stepData?.status === 'completed' && (
        <div className="mb-6 p-4 bg-green-50 border border-green-200 rounded-lg">
          <div className="flex items-center">
            <svg
              className="w-5 h-5 text-green-600 mr-2"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 13l4 4L19 7"
              />
            </svg>
            <span className="text-green-800 font-medium">
              Método de pago configurado exitosamente
            </span>
          </div>
        </div>
      )}

      <div className="bg-white p-8 rounded-lg border border-gray-200">
        <div className="text-center">
          <div className="mb-4">
            <div className="mx-auto w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center">
              <svg
                className="w-8 h-8 text-teal-600"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
                />
              </svg>
            </div>
          </div>
          <h3 className="text-lg font-semibold text-gray-900 mb-2">
            Configuración de Método de Pago
          </h3>
          <p className="text-gray-600 mb-6">
            Selecciona y configura el método de pago que utilizarás para
            realizar el pago inicial de tu contrato de leasing.
          </p>

          <div className="bg-gray-50 p-4 rounded-lg mb-6">
            <p className="text-sm text-gray-700">
              <strong>Tiempo estimado:</strong> 10 minutos
            </p>
          </div>

          <div className="bg-purple-50 p-4 rounded-lg mb-6 text-left">
            <h4 className="text-sm font-semibold text-purple-800 mb-2">
              Métodos de pago disponibles:
            </h4>
            <ul className="text-sm text-purple-700 space-y-1">
              <li>• Transferencia bancaria</li>
              <li>• Cheque certificado</li>
              <li>• Domiciliación bancaria</li>
              <li>• Depósito en sucursal</li>
            </ul>
          </div>

          <button
            onClick={handleComplete}
            disabled={stepData?.status === 'completed'}
            className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {stepData?.status === 'completed'
              ? 'Completado'
              : 'Simular Completar'}
          </button>
        </div>
      </div>
    </div>
  )
}

export default PaymentMethodStep
